import { isNumber } from 'lodash';
import { getFramework } from '@/framework';
import { ResultCanvasCreator as TextResultCanvasCreator } from '@/layers/text-layer';
import { deleteExtraInfo } from '@/utils/layer-kit';
import { transformClientVectorLayerDataToFoundation } from '@/utils/transform-kit';
import { type ILayerBehavior, type IVectorLayerProps } from '@/version-types';
import { PPTSaver, ResultCanvasCreator, transformToTextLayer } from '../utils';

type Behaviors = Pick<ILayerBehavior, 'onBeforeSaveAsync' | 'savePPTLayerAsync' | 'getResultCanvasAsync'>;

export const createSaveBehaviors = (identity: string) => {
    const behaviors: Behaviors = {
        async onBeforeSaveAsync(layer, isAutoSave) {
            const data = layer.data as IVectorLayerProps;
            deleteExtraInfo(layer);
            data.pickerIndex = isNumber(data.pickerIndex) ? data.pickerIndex : null;

            layer.data = transformClientVectorLayerDataToFoundation(data);
        },

        async savePPTLayerAsync(slide, layer, stageWidth, stageHeight, watermark, outFontFamilyArr) {
            const saver = new PPTSaver(identity, layer);
            await saver.save(slide, outFontFamilyArr);
        },

        async getResultCanvasAsync(layer, stageSize) {
            const creator = new ResultCanvasCreator(identity, layer, stageSize);

            const layerData = layer.data as IVectorLayerProps;
            const { textInfo } = layerData;

            let textResultCanvas: HTMLCanvasElement | undefined;
            if (textInfo && textInfo.text) {
                const framework = getFramework(identity);

                const fontSubsetToBase64: Record<string, string> = {};
                const fontFamilyMap = layer.__runtime?.fontFamilyMap;
                const fontBase64Dict = framework.getFontBase64(layer);

                if (fontFamilyMap) {
                    Object.keys(fontFamilyMap).forEach((fontFamily) => {
                        const key = fontFamilyMap[fontFamily];
                        if (fontBase64Dict[fontFamily]) {
                            fontSubsetToBase64[key] = fontBase64Dict[fontFamily];
                        }
                    });
                }

                const textLayer = transformToTextLayer(layer);
                const textCanvasCreator = new TextResultCanvasCreator(
                    identity,
                    textLayer,
                    stageSize,
                    fontSubsetToBase64,
                );
                textResultCanvas = await textCanvasCreator.create();
            }

            return creator.create(textResultCanvas);
        },
    };
    return behaviors;
};
